{
  "categories": {
    "certificates": "证书",
    "dashboard": "仪表盘",
    "dataTransfer": "数据传输",
    "other": "其他",
    "products": "产品",
    "suppliers": "供应商"
  },
  "title": "常见问题"
}
